import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';

type UseIsHeadersNavPhase1Enabled = () => boolean;
export const useIsHeadersNavPhase1Enabled: UseIsHeadersNavPhase1Enabled = () => {
  const treatment = useAndReportExperimentTreatment(Experiment.NavPhase1) as string;

  return ['pillars_header_menu', 'pillars_header_menu_search', 'pillars_header'].includes(treatment);
};
